import { Icons } from '../../FormRatings.support';
import { CustomIconsType, Rating, RatingProps } from '../../Rating/Rating';
import { RatingWrapperProps } from '../../Rating/Rating.styles';
import { RatingWrapper } from './HeartRating.styles';

export const HeartRating = (props: RatingProps): JSX.Element => {
  const generateCustomIcons = (count) => {
    const customIcons: CustomIconsType = {};
    for (let iconsCount = 1; iconsCount <= count; iconsCount++) {
      const { Heart } = Icons;
      customIcons[iconsCount] = {
        icon: <Heart />,
        label: props[`label${iconsCount}`],
      };
    }
    return customIcons;
  };

  const { count, iconColor, highlightColor } = props;

  const ratingWrapperProps: RatingWrapperProps = {
    iconColor,
    highlightColor,
  };

  const customIcons = generateCustomIcons(count);

  return (
    <RatingWrapper {...ratingWrapperProps}>
      <Rating customIcons={customIcons} {...props} />
    </RatingWrapper>
  );
};
